/**
 * epgTimeIndicatorBody.tsx
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const EpgTimeIndicatorBody = styled.div`
  background-color: #ff6200;
  position: relative;
  right: ${0.5 * Screen.widthRatio}px;
  top: ${-4 * Screen.widthRatio}px;
  height: ${1000 * Screen.widthRatio}px;
  width: ${4 * Screen.widthRatio}px;
`;

export default EpgTimeIndicatorBody;
